import styled from 'styled-components';

export default styled.h2`
  all: initial;
  display: block;
  padding: 25px 0;
  color: #11A9CE;
  font-weight: bold !important;
  font-size: 21px !important;
`;
